// Repeat Every options of the New Enquiry form, and the mapping from an
// employment level's repeat_every (NewLevelSlider vocabulary) onto them.

export const REPEAT_EVERY_OPTIONS = [
  { label: 'None', value: 'none', subLabel: 'one time' },
  { label: 'Monthly', value: 'monthly', subLabel: 'every 1 month' },
  { label: 'Quarterly', value: 'quarterly', subLabel: 'every 3 months' },
  { label: 'Semiannual', value: 'semi_annually', subLabel: 'every 6 months' },
  { label: 'Annual', value: 'annually', subLabel: 'yearly' },
]

// Level vocabulary → form value. 'none' is a real choice (one-time screening)
// and must prefill like the others; without it a level set to "None" left the
// field empty on every repeat enquiry. 'bi-monthly' has no equivalent option
// here, so it maps to nothing (the field is left for the user to pick) —
// Everest #86eybg411.
const LEVEL_REPEAT_TO_FORM = {
  none: 'none',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannual: 'semi_annually',
  annual: 'annually',
}

export function repeatEveryOptionFromLevel(raw) {
  if (!raw) return null
  const key = String(raw).toLowerCase().trim()
  // A value already in the form's vocabulary (semi_annually, annually) passes through.
  const formVal = LEVEL_REPEAT_TO_FORM[key] || key
  return REPEAT_EVERY_OPTIONS.find((o) => o.value === formVal) || null
}
